import { render, staticRenderFns } from "./TradeInAssetDetail.vue?vue&type=template&id=0633e0d9&"
import script from "./TradeInAssetDetail.vue?vue&type=script&lang=js&"
export * from "./TradeInAssetDetail.vue?vue&type=script&lang=js&"
import style0 from "./TradeInAssetDetail.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports